/**
 * Buchungsstrecke A5 (sql/585): die Gastseite meldet die ERSTE Variantenwahl und den Beginn der
 * Zusage an POST /api/public/offer/:token/ereignis.
 *
 * „Fire and forget": die Meldung darf die Seite NIE stoeren — kein await beim Aufrufer, jeder
 * Fehler (Netz, 4xx/5xx, sogar ein synchron werfendes fetch) wird verschluckt. Je Art hoechstens
 * EINE Meldung pro Seitenaufruf (`gesendet`); die Datenbank haelt ohnehin nur das erste Auftreten.
 * Keine Cookies, kein Speicher im Browser, keine Kennung ausser dem Angebots-Token.
 */
/** B4 (sql/603): `video_abgespielt` — erstes Abspielen des Begrüßungsvideos. */
export type AngebotsEreignisArt =
  | "variante_gewaehlt"
  | "zusage_begonnen"
  | "video_abgespielt"
  // Einblicke (sql/730): weitere Stationen, jeweils nur das erste Auftreten.
  | "preis_gesehen"
  | "zahlungsbedingungen_geoeffnet"
  | "anmerkung_begonnen"
  | "pdf_geladen";

export function meldeAngebotsEreignis(
  token: string | undefined,
  art: AngebotsEreignisArt,
  gesendet: Set<AngebotsEreignisArt>,
  vorschau: boolean,
): void {
  // Betreiber-Vorschau misst nichts — sie hat auch gar keinen Gast-Token.
  if (vorschau || !token || gesendet.has(art)) return;
  gesendet.add(art);
  try {
    void fetch(`/api/public/offer/${encodeURIComponent(token)}/ereignis`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ art }),
      // Ueberlebt einen direkt folgenden Seitenwechsel (z. B. Weiterleitung zur Zahlung).
      keepalive: true,
      credentials: "omit",
    }).catch(() => undefined);
  } catch {
    // bewusst still
  }
}
